import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import useFileImportStore from "../../../../stores/fileImportStore";

export default function useFileDataRequired() {
  const currentUnparsedBOM = useFileImportStore((s) => s.currentUnparsedBOM);
  const navigate = useNavigate();
  useEffect(() => {
    if (!currentUnparsedBOM) {
      Swal.fire({
        title: "Error!",
        text: "CSV data not found. Please re-upload your file.",
        icon: "error",
      }).then(() => {
        navigate("/dashboard/import-bom-csv/", { replace: true });
      });
    }
  }, [currentUnparsedBOM, navigate]);
}
